import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '@/components/layouts/AppLayout'

import DashboardPage from '@/pages/dashboard/DashboardPage'
import FileTypesPreviewPage from '@/pages/dashboard/FileTypesPreviewPage'

import cmsRoutes from './modules/cms';
import authRoutes from './modules/auth';
import settingsRoutes from './modules/settings';
import filesRoutes from './modules/files';
import publicRoutes from './modules/public';

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'AppLayout',
    component: AppLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/dashboard',
        name: 'DashboardPage',
        component: DashboardPage,
        meta: {
          title: 'Findus | Digital Archive - Archivio'
        }
      },
      {
        path: '/dashboard/file-type/:uuid',
        name: 'FileTypesPreviewPage',
        component: FileTypesPreviewPage,
        meta: {
          title: 'Findus | Digital Archive - Archivio'
        }
      },
      ...cmsRoutes,
      ...settingsRoutes,
      ...filesRoutes,
    ]
  },

  ...authRoutes,
  ...publicRoutes
];

export const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes
})

router.beforeEach((to, from, next) => {
  // Meta and Page Title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Requires Login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      location.href = '/login'
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js